import React, { useEffect, useState } from "react";
import "./associations.scss";

import { Box, Stack } from "@mui/material";

//Componenti
import SearchField from "../../components/searchField/SearchField";
import GeneralStats from "./components/generalStats/GeneralStats";
import ListAssociations from "./components/listAssociation/ListAssociations";
import DateFilter from "../../components/dateFilter/DateFilter";

import { getAssociationsStatsWS } from "./associationsApi";

import { gestioneSnackbar } from "../../utils/common";
import { isEmpty } from "../../utils/validation";

const Associations = () => {
  const [search, setSearch] = useState("");
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [generalStats, setGeneralStats] = useState({});
  const [filteredAssociations, setFilteredAssociations] = useState([]);
  const [associations, setAssociations] = useState([]);

  const refreshContent = ({ start, end }) => {
    getAssociationsStatsWS({ start, end })
      .then((res) => {
        setGeneralStats(res.general);
        setAssociations(res.associations);
        setFilteredAssociations(res.associations);
      })
      .catch((err) => gestioneSnackbar(true, err, "error"));
  };

  useEffect(() => {
    refreshContent({ start, end });
  }, []);

  useEffect(() => {
    if (search) {
      setFilteredAssociations(
        associations.filter((item) => {
          const name = item.name?.toLowerCase() || "";

          return name.includes(search.toLowerCase());
        })
      );
    } else {
      setFilteredAssociations(associations);
    }
  }, [search]);

  return (
    <Box>
      <Stack gap={2}>
        <SearchField setSearch={setSearch} />
        <DateFilter
          startDateTime={start}
          setStartDateTime={setStart}
          endDateTime={end}
          setEndDateTime={setEnd}
          APICall={() => refreshContent({ start, end })}
        />
        {!isEmpty(generalStats) ? <GeneralStats data={generalStats} /> : null}
        {!isEmpty(filteredAssociations) ? (
          <ListAssociations data={filteredAssociations} />
        ) : null}
      </Stack>
    </Box>
  );
};

export default Associations;
